import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "The studio comes to you",
    body: "No queues, no drop-offs, no waiting rooms. We arrive fully equipped with water, power and pro-grade product — and transform your vehicle wherever it's parked across Perth.",
    img: "https://images.pexels.com/photos/1633602/pexels-photo-1633602.jpeg",
  },
  {
    n: "02",
    title: "Detail obsessed, by hand",
    body: "Every panel, seam and stitch gets deliberate attention. We work by hand with a two-bucket method and the correct product for each surface — never a shortcut, never a swirl.",
    img: "https://images.unsplash.com/photo-1608506375591-b90e1f955e4b",
  },
  {
    n: "03",
    title: "A finish you can feel",
    body: "Slick paint, crisp glass, a cabin that smells factory-fresh. The result isn't just clean — it's protected, preserved and genuinely showroom. Clean. Protect. Perfect.",
    img: "https://images.pexels.com/photos/14231678/pexels-photo-14231678.jpeg",
  },
];

const Chapter = ({ c, i }) => (
  <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center py-16 md:py-24 border-t border-white/10">
    <div className="md:col-span-4">
      <span className="font-mono text-sm text-[#3377ff] tracking-[0.3em]">{c.n}</span>
      <motion.h3
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="font-display text-3xl md:text-4xl tracking-tight mt-4 leading-[1.05]"
      >
        {c.title}
      </motion.h3>
    </div>
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay: 0.1 }}
      className={`md:col-span-4 ${i % 2 === 1 ? "md:order-first" : ""}`}
    >
      <p className="text-white/55 text-base md:text-lg leading-relaxed">{c.body}</p>
    </motion.div>
    <motion.div
      initial={{ opacity: 0, scale: 1.05 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      className="md:col-span-4 overflow-hidden"
    >
      <img src={c.img} alt={c.title} className="w-full h-64 md:h-72 object-cover grayscale-[30%] hover:grayscale-0 transition-all duration-700" />
    </motion.div>
  </div>
);

export const Manifesto = () => (
  <section id="manifesto" className="mx-auto max-w-[1500px] px-6 md:px-12 py-24 md:py-32" data-testid="manifesto">
    <div className="max-w-2xl">
      <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#3377ff]">The Ethos</span>
      <h2 className="font-display text-4xl md:text-6xl tracking-tighter mt-4 leading-[0.95]">
        Not a car wash.<br />A restoration ritual.
      </h2>
    </div>
    <div className="mt-8">
      {chapters.map((c, i) => (
        <Chapter key={c.n} c={c} i={i} />
      ))}
    </div>
  </section>
);
